import { Navigate, useLocation, useParams } from 'react-router-dom'
import { mapLegacyDashboardPath } from '@/config/routes'

/**
 * Catch-all for old React `/dashboard/{module}/...` URLs (pre Angular parity).
 * `/dashboard` alone is the home page and is not redirected.
 */
export function LegacyDashboardPathRedirect() {
  const { pathname, search, hash } = useLocation()
  const mapped = mapLegacyDashboardPath(pathname)
  if (!mapped || mapped === pathname) {
    return <Navigate to="/dashboard" replace />
  }
  return <Navigate to={{ pathname: mapped, search, hash }} replace />
}

/** `/dashboard/invite/edit/:code` → `/invite/edit/:code` */
export function LegacyInviteEditRedirect() {
  const { code } = useParams<{ code: string }>()
  return <Navigate to={`/invite/edit/${code ?? ''}`} replace />
}

/**
 * `/dashboard/residents/resident-detail/:a/:u` and
 * `/dashboard/reimbursements/detail/:a/:u` splat redirects when nested under
 * the legacy catch-all; explicit helpers for clarity in the route tree.
 */
export function LegacyResidentDetailRedirect() {
  const { applicantId, userId } = useParams<{
    applicantId: string
    userId: string
  }>()
  const { search, hash } = useLocation()
  return (
    <Navigate
      to={{
        pathname: `/resident/resident-detail/${applicantId ?? ''}/${userId ?? ''}`,
        search,
        hash,
      }}
      replace
    />
  )
}

export function LegacyReimbursementDetailRedirect() {
  const { applicantId, userId } = useParams<{
    applicantId: string
    userId: string
  }>()
  const { search, hash } = useLocation()
  return (
    <Navigate
      to={{
        pathname: `/defaults/default-detail/${applicantId ?? ''}/${userId ?? ''}`,
        search,
        hash,
      }}
      replace
    />
  )
}

/** `/reimbursements` or `/reimbursements/...` → Angular `/defaults`. */
export function LegacyReimbursementsPathRedirect() {
  const { pathname, search, hash } = useLocation()
  const mapped = mapLegacyDashboardPath(pathname)
  if (!mapped || mapped === pathname) {
    return <Navigate to="/defaults" replace />
  }
  return <Navigate to={{ pathname: mapped, search, hash }} replace />
}
